module.exports = __webpack_public_path__ + "img/face.7ede5178.png";